'use strict';

var _inView = require('in-view');

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initAddToCartButton = function initAddToCartButton() {
  var body = document.querySelector('body');

  if (!body) {
    return;
  }

  (0, _inView2.default)('.add-to-cart-button').on('enter', function () {
    body.classList.remove('show-add-to-cart-button-bottom');
  }).on('exit', function () {
    body.classList.add('show-add-to-cart-button-bottom');
  });
};

initAddToCartButton();